import React, { Component } from 'react';

class FloatingLabelTextArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: false,
    };
  }

  handleFocus = () => {
    this.setState({ focused: true });
  };

  handleBlur = () => {
    this.setState({ focused: false });
  };

  render() {
    const { id, label, placeholder, value, onChange, maxLength = 300, disabled= 'false' } = this.props;
    const { focused } = this.state;

    return (
      <div className="floating-textarea-container">
        <div className={`floating-textarea-wrapper ${focused ? 'active' : ''}`}>
          {focused && <label className="floating-text-label">{label}</label>}
          <textarea
            id={id}
            className="floating-textarea"
            placeholder={!focused ? placeholder : ''}
            value={value}
            onChange={onChange}
            maxLength={maxLength}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            rows={4}
            disabled={disabled}
          />
        </div>
        <div className="floating-textarea-char-count">{value.length} / {maxLength}</div>
      </div>
    );
  }
}

export default FloatingLabelTextArea;